import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AppValueTypes } from '@iotv/iotv-v3-types';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import { Box, Button, Card, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { v4 } from 'uuid';
import { StaticLoadingAnimation } from '../../../Popup/Loading';
import { DeviceDAO } from '../../../data/SystemManagementDAO';
import { AdjacentType, ComponentMode, ObjectViewType, Severity, } from '../../../types/AppTypes';
import { ListerlizerAdapter } from '../../factories/Listerlizer/legacy/ListerlizerAdapter';
import styles from './ProvisionCard.module.css';
/** @deprecated - Not used in LSC */
const ProvisionCard = (props) => {
    const { contextCustomer, user, customerOptions, devices, userFunctions, transactionFunctions, close } = props;
    const [selectedObjects, setSelectedObjects] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState();
    const [saving, setSaving] = useState(false);
    const [result, setResult] = useState();
    /**
     * CAUTION. THIS FUNCTION IS DESIGNED JUST FOR VENTURE LEVEL MOVEMENT.
     * DEVICE EDGES NEED TO BE DELETED ON OTHER CUSTOMERS
     * @param devices
     * @param customer
     */
    const moveDeviceToCustomer = async (contextUser, devices, customer) => {
        setSaving(true);
        userFunctions.setUserMessage({
            id: v4(),
            content: `WARNING: This is unlikely to have been tested. Does not take into account any business rules. To Be Addressed`,
            label: 'CAUTIONARY',
            type: 'MessageBar',
            severity: Severity.error,
        });
        const provisionPromises = devices.map(async (device) => {
            const request = {
                contextUser: contextUser,
                contextCustomer: contextCustomer,
                assignmentCustomer: customer,
                device: device,
            };
            return DeviceDAO.assignDeviceToCustomer(request);
        });
        Promise.all(provisionPromises).then((res) => {
            setResult(res);
            setSaving(false);
        });
        // get all device groups that are not linked to seed customer.
    };
    const getListerlizer = (context) => {
        return {
            initMode: ComponentMode.EDIT,
            transactionFunctions,
            userFunctions,
            adjacentFilter: {
                adjacentType: AdjacentType.CHILD,
                objectType: 'Device',
            },
            autoQuery: true,
            columnVisibilityReferences: {
                dataTableReference: 'List',
                objectTypeId: 'ValidBusinessObject',
                viewType: ObjectViewType.List,
                externalColumnVisibility: undefined,
            },
            viewDefinition: {
                name: {
                    key: 'name',
                    type: AppValueTypes.STRING,
                    label: 'Devices',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                id: {
                    key: 'id',
                    type: AppValueTypes.STRING,
                    label: 'ID',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                state: {
                    key: 'state',
                    type: AppValueTypes.STRING,
                    label: 'State',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                version: {
                    key: 'version',
                    type: AppValueTypes.STRING,
                    label: 'Version',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                billingGroup: {
                    key: 'billingGroup',
                    type: AppValueTypes.STRING,
                    label: 'Group',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
            },
            viewObject: {
                matchedPrimary: undefined,
                matchedRelatedByPk: [],
                matchedRelatedBySk: context,
            },
            contextObject: undefined,
            searchRootObject: undefined,
            selectorConfigParams: {
                controls: {},
            },
            onSelectedUpdate: setSelectedObjects,
        };
    };
    const getResultListerlizer = (context) => {
        return {
            initMode: ComponentMode.VIEW,
            transactionFunctions,
            userFunctions,
            adjacentFilter: {
                adjacentType: AdjacentType.CHILD,
                objectType: 'Device',
            },
            autoQuery: false,
            columnVisibilityReferences: {
                dataTableReference: 'List',
                objectTypeId: 'ValidBusinessObject',
                viewType: ObjectViewType.List,
                externalColumnVisibility: undefined,
            },
            viewDefinition: {
                name: {
                    key: 'name',
                    type: AppValueTypes.STRING,
                    label: 'Devices',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                id: {
                    key: 'id',
                    type: AppValueTypes.STRING,
                    label: 'ID',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
                version: {
                    key: 'version',
                    type: AppValueTypes.STRING,
                    label: 'Version',
                    editable: false,
                    precision: undefined,
                    stateFn: undefined,
                    unit: undefined,
                    validationRx: undefined,
                    enumKV: undefined,
                },
            },
            viewObject: {
                matchedPrimary: undefined,
                matchedRelatedByPk: [],
                matchedRelatedBySk: context,
            },
            contextObject: undefined,
            searchRootObject: undefined,
            selectorConfigParams: {
                controls: {},
            },
        };
    };
    const updateSelectedCustomer = (id, customers) => {
        const found = customers.find((customer) => customer.id === id);
        setSelectedCustomer(found);
    };
    if (result === undefined) {
        return (_jsxs(_Fragment, { children: [_jsxs(Card, { children: [_jsx("div", { id: "Provision-Header", children: _jsxs(Stack, { direction: "row", spacing: 2, sx: { justifyContent: 'space-between', alignItems: 'center' }, children: [_jsx(DialogTitle, { id: "alert-dialog-title", children: "Provision Devices" }), _jsx(IconButton, { edge: "end", color: "warning", onClick: close, "aria-label": "close", children: _jsx(Box, { sx: { m: 1 }, children: _jsx(CancelPresentationIcon, {}) }) })] }) }), _jsx("div", { className: styles.provisionBody, children: _jsx(Box, { sx: { m: 1 }, children: _jsx(ListerlizerAdapter, { ...getListerlizer(devices) }) }) }), _jsx(Box, { sx: { m: 2 }, children: _jsxs(Stack, { direction: "row", spacing: 2, sx: { justifyContent: 'flex-end', alignItems: 'center' }, children: [_jsx("div", { style: { width: '300px' }, children: _jsxs(FormControl, { fullWidth: true, children: [_jsx(InputLabel, { id: "customer-label", children: "Select Customer" }), _jsx(Select, { labelId: "customer-label", id: "customer-select", value: selectedCustomer?.name, label: "Customers", onChange: (e) => {
                                                        updateSelectedCustomer(e.target.value, customerOptions);
                                                    }, children: customerOptions.map((customer) => {
                                                        return (_jsx(MenuItem, { value: customer.id, children: customer.name }, customer.id));
                                                    }) })] }) }), _jsx(Button, { variant: "contained", color: "primary", disabled: selectedCustomer === undefined || selectedObjects.length === 0, onClick: () => user && moveDeviceToCustomer(user, selectedObjects, selectedCustomer), children: "Apply" })] }) })] }), saving && _jsx(StaticLoadingAnimation, { message: 'Provisioning Devices, Please Wait...' })] }));
    }
    else {
        const sucess = result
            .map((res) => {
            if (res && res.err === null && res.data) {
                return res.data.device;
            }
            else {
                return undefined;
            }
        })
            .filter((data) => data !== undefined);
        const successPk = sucess.map((edge) => edge.sk);
        const formattedData = devices.filter((dev) => successPk.includes(dev.pk));
        const failed = devices.filter((device) => !formattedData.map((data) => data.id).includes(device.id));
        return (_jsx(_Fragment, { children: _jsxs(Card, { children: [_jsx("div", { id: "Result-Header", children: _jsxs(Stack, { direction: "row", spacing: 2, sx: { justifyContent: 'space-between', alignItems: 'center' }, children: [_jsx(DialogTitle, { id: "alert-dialog-title", children: "Provision Devices Result" }), _jsx(IconButton, { edge: "end", color: "warning", onClick: close, "aria-label": "close", children: _jsx(Box, { sx: { m: 1 }, children: _jsx(CancelPresentationIcon, {}) }) })] }) }), _jsx("div", { className: styles.provisionBody, children: _jsx(Box, { sx: { m: 1 }, children: _jsxs(Stack, { direction: "row", spacing: 2, sx: { justifyContent: 'center', alignItems: 'center' }, children: [_jsxs("div", { className: failed.length !== 0 ? styles.tables : styles.provisionBody, children: [_jsx(Typography, { variant: "h6", component: "h6", children: "Success" }), _jsx(ListerlizerAdapter, { ...getResultListerlizer(formattedData) })] }), failed.length !== 0 && (_jsxs("div", { className: styles.tables, children: [_jsx(Typography, { variant: "h6", component: "h6", children: "Fails" }), _jsx(ListerlizerAdapter, { ...getResultListerlizer(failed) })] }))] }) }) })] }) }));
    }
};
export default ProvisionCard;
